<template>
 <div :class="windowClass">
        <v-row no-gutters class="pa-2">
            <v-col cols="12">
                <v-card>
                        <v-toolbar dense >
                    <span style="width: 270px;" class="ml-4">
                       <v-menu
                        ref="menu"
                        v-model="menu"
                        :close-on-content-click="false"
                        transition="scale-transition"
                        offset-y
                        min-width="300px"
                      >
                        <template v-slot:activator="{ on }">
                          <v-text-field
                            :value="from_date +' - '+to_date"
                            label="Date range"
                            prepend-icon="mdi-calendar"
                              dense
                              solo
                              hide-details
                            readonly
                            v-on="on"
                          ></v-text-field>
                        </template>
                        <v-date-picker v-model="from_date" no-title scrollable class="mr-1">  </v-date-picker>
                         <v-date-picker v-model="to_date" no-title scrollable @input="getItems(),menu = false">  </v-date-picker>
                      </v-menu>
                  </span>
                   <span style="width: 290px;" class="ml-2">
                        <v-text-field
                            v-model="search"
                            append-icon="mdi-magnify"
                            label="Search"
                            solo
                            dense
                            hide-details
                        ></v-text-field>
                        </span>
                        <v-spacer/>
                         <v-btn small text color="success"  @click="state='new', billingform=true"><v-icon left >mdi-plus-box</v-icon> Issue BILLING</v-btn>
                        </v-toolbar>
                             <v-data-table
                                class="va-table mt-3"
                                :headers="headers"
                                :search="search"
                                :items="billings"
                                >
                                <template v-slot:body="{ items }">
                                    <tbody>
                                    <tr v-for="(item,index) in items" :key="index">
                                           <td>
                                             <v-icon left small color="primary" @click="billing=item,state='update', billingform=true">mdi-open-in-new</v-icon>
                                             {{item.ar_num}}</td>
                                            <td>{{item.issued_date | moment("YY-MMM-DD")}}</td>
                                            <td>{{item.customer.lastname}}, {{item.customer.firstname}}</td>
                                            <td>{{item.customer.trade_name}}</td>
                                            <td :class="STATUS_TEXT(item.status)"> 
                                              <v-icon v-if="item.status=='paid'" left small color="succcess">mdi-check</v-icon>
                                               {{item.status}}
                                              </td>
                                             <td class="text-right">{{$money(item.amount)}}</td>
                                    </tr>
                                    </tbody>
                                </template>
                          </v-data-table>
                    </v-card>
            </v-col>
        </v-row>


        <v-row no-gutters class="pa-2">
            <v-col cols="12">
                <v-card>
                        <v-toolbar dense >
                          <v-icon left color="primary">mdi-account-cash-outline</v-icon> Payment History
                          <v-spacer/>
                    <span style="width: 270px;" class="ml-4">
                       <v-menu
                        ref="menu2"
                        v-model="menu2"
                        :close-on-content-click="false"
                        transition="scale-transition"
                        offset-y
                        min-width="300px"
                      >
                        <template v-slot:activator="{ on }">
                          <v-text-field
                            :value="from_date2 +' - '+to_date2"
                            label="Date range"
                            prepend-icon="mdi-calendar"
                              dense
                              solo
                              hide-details
                            readonly
                            v-on="on"
                          ></v-text-field>
                        </template>
                        <v-date-picker v-model="from_date2" no-title scrollable class="mr-1">  </v-date-picker>
                         <v-date-picker v-model="to_date2" no-title scrollable @input="getPayments(),menu2 = false">  </v-date-picker>
                      </v-menu>
                  </span>
                   <span style="width: 290px;" class="ml-2">
                        <v-text-field
                            v-model="search2"
                            append-icon="mdi-magnify"
                            label="Search"
                            solo
                            dense
                            hide-details
                        ></v-text-field>
                        </span>
                        </v-toolbar>
                             <v-data-table
                                class="va-table mt-3"
                                :headers="headers2"
                                :search="search2"
                                :items="payments"
                                >
                                <template v-slot:body="{ items }">
                                    <tbody>
                                    <tr v-for="(item,index) in items" :key="index">
                                          
                                            <td>{{item.customer.lastname}}, {{item.customer.firstname}}</td>
                                            <td>{{item.customer.trade_name}}</td>
                                            <td>{{item.payment_date | moment("YY-MMM-DD hh:mm A")}}</td>
                                             <td>{{item.payment_method}}</td>
                                            <td :class="STATUS_TEXT(item.status)"> <v-icon v-if="item.status=='paid'" left small color="succcess">mdi-check</v-icon> {{item.status}}</td>
                                             <td class="text-right">{{$money(item.amount)}}</td>
                                    </tr>
                                    </tbody>
                                </template>
                          </v-data-table>
                    </v-card>
            </v-col>
        </v-row>
        <va-billing-form :show="billingform" :item="billing" :state="state" @DialogEvent="bfEvent"/>
  </div>
</template>
<script>
import {
  mapMutations
} from 'vuex'
  export default {
    data: () => ({
      billingform: false,
        menu: false,
        menu2:false,
        state:'',
        search:'',
        to_date:'',
        from_date: '',
        search2:'',
        to_date2:'',
        from_date2: '',
        receivables:[],
         payments:[],
        billings:[],
        billing:{},
        headers: [
          {text: "A.R. NO."},
          {text: "Issued Date", value:'issued_date'},
          {text: "Billed To", value:'customer.lastname'},
          {text: "Trade Name", value:'customer.trade_name'},
          {text: "Status", value:'status'},
          {text: "Amount", align:'right'},
        ],
        headers2: [
          {text: "Billed To", value:'customer.lastname'},
          {text: "Trade Name", value:'customer.trade_name'},
          {text: "Payment Date", value:'payment_date'},
           {text: "Method", value:'payment_method'},
          {text: "Status", value:'status'},
          {text: "Amount", align:'right'},
        ]
    }),
    beforeCreate: function () {
      if (!this.$session.exists()) {
        this.$router.push('/')
      }
    },
    created() {
       if (this.$session.exists()) {
          this.$http.defaults.headers.common['Authorization'] = 'Bearer ' + this.$session.get('jwt')
          this.setLoggedIn(true)
            this.SET_MENUS()
          this.GET_CUSTOMERS('active')
           var current_date = this.$moment()
         var startdate = current_date.subtract(30, "days")
          this.from_date =  this.$moment(startdate).format("YYYY-MM-DD")
          this.to_date =  this.$moment().format("YYYY-MM-DD")
           this.from_date2 =  this.$moment(startdate).format("YYYY-MM-DD")
          this.to_date2 =  this.$moment().format("YYYY-MM-DD")
          this.getItems()
          this.getPayments()
          this.GET_SETTINGS()
        }
    },
    computed:{
       windowClass() {
        if(this.$store.state.responsive){
          return "va-reponsive"
        } else {
          return "va-not-reponsive"
        }
      },
    },
    methods: {
      ...mapMutations(['setAlert', 'setAlertColor', 'setAlertText', 'setLoggedIn']),
      bfEvent(){
        this.billingform = false
        this.getItems()
      },
       getItems() {
        this.$http.post("billing/list",  {from_date:this.from_date, to_date: this.to_date}).then(response => {
              response.data.items != null?this.billings = response.data.items:this.billings=[]
          }).catch(e => {
           console.log(e.data)
         })
      },
      getPayments() {
        this.$http.post("payments/list",  {from_date:this.from_date2, to_date: this.to_date2}).then(response => {
              response.data.items != null?this.payments = response.data.items:this.payments=[]
          }).catch(e => {
           console.log(e.data)
         })
      }
    },
  }
</script>